import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/app.component.ts